// PrivateRoute.js
import React, { useEffect, useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "./AuthContext";
import { getPerms2 } from "layout-components/Sidebar/menuPerms";
import userContext from "contexts/userContext";
import navItems from "layout-components/Sidebar/navItems";

const PrivateRouteAuthGuard = ({ component: Component, ...rest }) => {
  const { isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    console.log(
      "isAuthenticated changed(PrivateRouteAuthGuard), isAuthenticated : ",
      isAuthenticated
    );
  }, [isAuthenticated]);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/Login" />
      }
    />
  );
};

export default PrivateRouteAuthGuard;
